import { render, staticRenderFns } from "./StockAlert.vue?vue&type=template&id=146a5738&scoped=true"
import script from "./StockAlert.vue?vue&type=script&lang=js"
export * from "./StockAlert.vue?vue&type=script&lang=js"
import style0 from "./StockAlert.vue?vue&type=style&index=0&id=146a5738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146a5738",
  null
  
)

export default component.exports